import React, {MouseEvent} from "react";
import {Col, Row} from "react-bootstrap";
import Button from "../Button/Button";
import {Dark2, WerfenColor, White} from "../../Constants/ColorChart";

type LoginButtonProps = {
    submitClick: (event: MouseEvent<HTMLDivElement>) => void;
    loginClick: (event: MouseEvent<HTMLDivElement>) => void;
    reason: string;
    checked: boolean;
};

const LoginButton: React.FC<LoginButtonProps> = ({reason, checked, submitClick, loginClick}) => {
    const canSeeButton: boolean = process.env.REACT_APP_SEE_ACCESS_LOG === '1';
    const canShowSubmit: boolean = !canSeeButton || reason !== '' && checked;
    const canShowLogin: boolean = canSeeButton && reason === '' || !checked;

    return (
        <Row>
            <Col lg={{span: 2, offset: 5}} xs={{span: 10, offset: 1}}>
                {
                    canShowSubmit &&
                    <Button
                        centered
                        miniSized
                        text="LOG IN"
                        background={White}
                        color={WerfenColor}
                        onClick={submitClick}
                    />
                }
                {
                    !canShowSubmit && canShowLogin &&
                    <Button
                        centered
                        miniSized
                        text="LOG IN"
                        background={Dark2}
                        color={WerfenColor}
                        onClick={loginClick}
                    />
                }
            </Col>
        </Row>
    );
}

export default LoginButton;